import { render, staticRenderFns } from "./UserSidebar.vue?vue&type=template&id=176d9c6b&"
import script from "./UserSidebar.vue?vue&type=script&lang=js&"
export * from "./UserSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports